<template>
    <div
        class="images_list flex"
        :style="{ 'justify-content': value.alignment }"
    >
        <picture
            v-full-image-path="value"
            class="flex"
            :style="{ 'justify-content': 'center' }"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
